<template>
  <div class="flex-column pb-1" :style="style" @click="(e) => $emit('click', e)">
    <img :src="item.image_url" style="width: 100%"/>
    <div v-if="!small" class="mt-n1 text-center" style="font-size: 10px;">
      {{ item.brand_name }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'RewardsCatalogItem',

  props: { 
    item: Object,
    small: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    style() {
      return {
        width: this.small ? '95px' : '47%',
      }
    },
  },
}
</script>
